// 提取初始化Swiper的函数，以便可以重复调用
function initProductSwipers(container) {
  const thumbsContainer = container.querySelector('.product-swiper-thumbs');
  const mainContainer = container.querySelector('.product-swiper-main');
  
  if (thumbsContainer && mainContainer) {
    // 检查图片数量
    const mainSlides = mainContainer.querySelectorAll('.swiper-slide');
    const slideCount = mainSlides.length;
    
    // 如果图片数量少于2张，隐藏导航按钮
    if (slideCount < 2) {
      const mainNextBtn = mainContainer.querySelector('.swiper-button-next');
      const mainPrevBtn = mainContainer.querySelector('.swiper-button-prev');
      const thumbsNextBtn = thumbsContainer.querySelector('.swiper-button-next');
      const thumbsPrevBtn = thumbsContainer.querySelector('.swiper-button-prev');
      
      if (mainNextBtn) mainNextBtn.style.display = 'none';
      if (mainPrevBtn) mainPrevBtn.style.display = 'none';
      if (thumbsNextBtn) thumbsNextBtn.style.display = 'none';
      if (thumbsPrevBtn) thumbsPrevBtn.style.display = 'none';
    }
    
    // 检查容器是否已初始化
    if (container.classList.contains('swiper-initialized')) {
      return; // 如果已初始化，则跳过
    }
    
    const productThumbsSwiper = new Swiper(thumbsContainer, {
      spaceBetween: 5,
      slidesPerView: 5,
      freeMode: true,
      watchSlidesProgress: true,
      loop: false,
      navigation: {
        nextEl: thumbsContainer.querySelector('.swiper-button-next'),
        prevEl: thumbsContainer.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        320: {
          slidesPerView: 4,
          spaceBetween: 3
        },
        480: {
          slidesPerView: 5,
          spaceBetween: 5
        },
        640: {
          slidesPerView: 5,
          spaceBetween: 5
        }
      }
    });
    
    const productMainSwiper = new Swiper(mainContainer, {
      spaceBetween: 10,
      loop: false,
      navigation: {
        nextEl: mainContainer.querySelector('.swiper-button-next'),
        prevEl: mainContainer.querySelector('.swiper-button-prev'),
      },
      thumbs: {
        swiper: productThumbsSwiper,
      },
    });
    
    // 动态处理显示/隐藏导航按钮
    if (slideCount <= productThumbsSwiper.params.slidesPerView) {
      const thumbsNextBtn = thumbsContainer.querySelector('.swiper-button-next');
      const thumbsPrevBtn = thumbsContainer.querySelector('.swiper-button-prev');
      if (thumbsNextBtn) thumbsNextBtn.style.display = 'none';
      if (thumbsPrevBtn) thumbsPrevBtn.style.display = 'none';
    }
    
    // 标记容器已初始化
    container.classList.add('swiper-initialized');
  }
}

// 初始化页面加载时的Swiper
document.addEventListener('DOMContentLoaded', function() {
  const swiperContainers = document.querySelectorAll('.product-swiper-container');
  
  if (swiperContainers.length > 0) {
    swiperContainers.forEach(function(container) {
      initProductSwipers(container);
    });
  }
});

// 为动态加载的内容创建MutationObserver
function initMutationObserver() {
  // 创建一个观察器实例
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      // 检查是否有新节点添加
      if (mutation.addedNodes && mutation.addedNodes.length > 0) {
        // 遍历新添加的节点
        mutation.addedNodes.forEach(function(node) {
          // 检查节点是否是元素节点
          if (node.nodeType === 1) {
            // 检查节点本身是否是产品轮播容器
            if (node.classList && node.classList.contains('product-swiper-container')) {
              initProductSwipers(node);
            }
            
            // 检查节点内是否有产品轮播容器
            const containers = node.querySelectorAll('.product-swiper-container');
            if (containers.length > 0) {
              containers.forEach(function(container) {
                initProductSwipers(container);
              });
            }
          }
        });
      }
    });
  });
  
  // 配置观察选项
  const config = { 
    childList: true, // 观察目标子节点的变化
    subtree: true // 观察所有后代节点
  };
  
  // 开始观察document.body的变化
  observer.observe(document.body, config);
}

// 初始化MutationObserver
document.addEventListener('DOMContentLoaded', initMutationObserver);

// 提供公共方法用于手动初始化
window.initProductCardSwiper = function(selector) {
  const containers = document.querySelectorAll(selector || '.product-swiper-container');
  if (containers.length > 0) {
    containers.forEach(function(container) {
      initProductSwipers(container);
    });
  }
}; 